module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', {
    staticClass: "col-sm-2 control-label text-label"
  }, [_vm._v("\n        QA/QC Status:\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 alert text-label",
    class: _vm.qaqcAlertClass(_vm.sectionName)
  }, [_vm._v(_vm._s(_vm.qaqcProgressDto[_vm.sectionName] ? 'Completed' : 'Not Completed'))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        _vm.qaqcMarkAll(1)
      }
    }
  }, [_vm._v("Replace All")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.qaqcMarkAll(2)
      }
    }
  }, [_vm._v("Ignore All")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.qaqcMarkAll(3)
      }
    }
  }, [_vm._v("Append All")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.completeSection(_vm.sectionName)
      }
    }
  }, [_vm._v("Complete Section")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5da00c72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteForm/QaqcFormFieldFooter.vue
// module id = 946
// module chunks = 1